import React from 'react';
import { NavItem } from 'react-bootstrap';
import CountTabTitle from 'components/core/CountTabTitle';


const JobToTraListTab = (props) => {
  const {
    eventKey,
    activeKey,
    onSelect,
    title,
    jobs,
    isLoading
  } = props;

  return (
    <NavItem
      active={eventKey === activeKey}
      eventKey={eventKey}
      onSelect={onSelect}>
      <CountTabTitle
        title={title}
        isLoading={isLoading}
        count={jobs.length} />
    </NavItem>
  );
}

export default JobToTraListTab;
